module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5LjMyMiIgaGVpZ2h0PSIxNi4zMDUiIHZpZXdCb3g9IjAgMCA5LjMyMiAxNi4zMDUiPg0KICA8cGF0aCBpZD0iSWNvbl9pb25pYy1pb3MtYXJyb3ctYmFjayIgZGF0YS1uYW1lPSJJY29uIGlvbmljLWlvcy1hcnJvdy1iYWNrIiBkPSJNMTQuMDYxLDE0LjM0NCwyMC4yMyw4LjE4YTEuMTY1LDEuMTY1LDAsMSwwLTEuNjUtMS42NDVsLTYuOTksNi45ODVhMS4xNjMsMS4xNjMsMCwwLDAtLjAzNCwxLjYwN2w3LjAxOSw3LjAzM2ExLjE2NSwxLjE2NSwwLDEsMCwxLjY1LTEuNjQ1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjAuNTcyIDIyLjQ5OSkgcm90YXRlKDE4MCkiLz4NCjwvc3ZnPg0K"


//////////////////
// WEBPACK FOOTER
// ./static/blog/img/icn_next.svg
// module id = LJHr
// module chunks = 0